import { trackUser } from '@api/tracking/client';
import type { TrackCheckoutEventParamsT } from '@mentimeter/billing-address';

export function trackCheckoutEvent({
  event,
  additionalProperties,
}: TrackCheckoutEventParamsT) {
  trackUser({
    event,
    properties: {
      context: 'Checkout',
      ...additionalProperties,
    },
  });
}
